import React from 'react';

const Footer = () => {
    return (
        <footer className="footer">
            <p>&copy; 2024 OliveiraDevs - Todos os direitos reservados.</p>
        </footer>
    );
};

export default Footer;